import { render, staticRenderFns } from "./accessDoorControlGateList.vue?vue&type=template&id=12d711d9&scoped=true"
import script from "./accessDoorControlGateList.vue?vue&type=script&lang=js"
export * from "./accessDoorControlGateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d711d9",
  null
  
)

export default component.exports